import { render, staticRenderFns } from "./PaywayGroup.vue?vue&type=template&id=28edc129&scoped=true"
import script from "./PaywayGroup.vue?vue&type=script&lang=js"
export * from "./PaywayGroup.vue?vue&type=script&lang=js"
import style0 from "./PaywayGroup.vue?vue&type=style&index=0&id=28edc129&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28edc129",
  null
  
)

export default component.exports